import UIFullScreenModal from './UIFullScreenModal.vue'
import UIModal from './UIModal.vue'
import UIModalBody from './UIModalBody.vue'
import UIModalCancelButton from './UIModalCancelButton.vue'
import UIModalFooter from './UIModalFooter.vue'
import UIModalFooterText from './UIModalFooterText.vue'
import UIModalSubmitButton from './UIModalSubmitButton.vue'

export {
  UIFullScreenModal,
  UIModalBody,
  UIModalCancelButton,
  UIModalFooter,
  UIModalFooterText,
  UIModalSubmitButton
}
export default UIModal
